<div>
  <div cdkDropList class="list" (cdkDropListDropped)="drop($event)">
    @for (item of employees(); track item) {
      <div class="box" cdkDrag nz-row>
        <div nz-col nzFlex="auto">
          {{item.user.firstname}} {{item.user.lastname}}
        </div>
        <button nz-button nzType="default" nzShape="circle" (click)="openEmployeeCalendar(item)">
          <i nz-icon nzType="calendar" nzTheme="outline"></i>
        </button>
        <div class="handle" cdkDragHandle>
          <button nz-button nzType="default" nzShape="circle">
            <i nz-icon nzType="drag" nzTheme="outline"></i>
          </button>
        </div>
      </div>
    }
  </div>
  <nz-divider></nz-divider>
  <button nzType="primary" (click)="update()" nz-button>{{'buttons.save' | translate}}</button>
</div>
